module.exports = __webpack_public_path__ + "resources/img/guide-hand1.6b44eaab.png";